export var ACCOUNT_ORG_STATUSES = {
    PENDING: 1,
    ACTIVE: 2,
    INACTIVE: 3,
};
export var ORG_CLASSIFICATIONS = {
    1: 'Commercial Bank',
    2: 'Consumer Goods Manufacturer',
    3: 'Development Finance Institution',
    4: 'Governmental Organization',
    5: 'Investment Fund',
    6: 'NGO',
    7: 'Producer',
    8: 'Retailer',
    9: 'Processor/Trader',
    10: 'Service Provider',
};
